<template>
    <header :class="styleMain">
      <span v-show="competition" class="competition">{{ competition }}</span>
      <span v-show="matchId" class="match">{{ teamTitle }}</span>
      <span v-show="matchStopwatch" class="stopwatch">{{ matchStopwatch }}</span>
      <span v-show="matchStatusName" class="status">{{ matchStatusName }}</span>
      <span class="user" :data-connected="connected" :data-connected-match="connectedMatch">{{ user }}</span>
    </header>
</template>

<script>
import { status } from '@/store/model/sport/football/Status'
import { stopwatch } from '@/helpers/format'

export default {
  name: 'SportFootballMatchHeader',
  props: {
    match: Object
  },
  data () {
    return {
      styleLoaded: null
    }
  },
  computed: {
    competition () { return this.match?.competition.name },

    matchId () { return this.match?.id },
    matchStatusName () { return status.name(this.match?.statusId) },
    matchStopwatch () { return stopwatch(this.match?.dateStartOffset, this.$store.getters['Server/live'], this.match?.statusId) },

    teamHome () { return this.$store.getters['Sport/Football/Team/team'](this.match?.teamHomeId) },
    teamHomeName () { return this.teamHome?.name },
    teamHomeId () { return this.teamHome?.id },
    teamAway () { return this.$store.getters['Sport/Football/Team/team'](this.match?.teamAwayId) },
    teamAwayName () { return this.teamAway?.name },
    teamAwayId () { return this.teamAway?.id },
    teamTitle () { return this.teamHomeName && this.teamAwayName ? `${this.teamHomeName} vs ${this.teamAwayName}` : 'Equipe locale vs Equipe visiteuse' },

    user () { return this.match?.user?.login },
    connected () {
      if (this.match) {
        return this.$store.getters['Server/userConnected'](this.match.user.id)
      }

      return false
    },
    connectedMatch () {
      if (this.match && this.match.user) {
        return this.$store.getters['Server/userConnectedPath'](this.match.user.id, '/Sports/Football/Match/' + this.match.id)
      }

      return false
    },

    styleMain () { return ['sportFootballMatchHeader', this.styleLoaded] }
  },
  watch: {
    teamTitle () {
      this.headTitle()
    },
    competition () {
      this.headTitle()
    }
  },
  updated () {
    this.styleLoaded = 'loaded'
  },
  methods: {
    headTitle () {
      document.title = this.teamTitle + ' - ' + this.match.competition.name + ' - Football/Sport - iDalgoAdmin'
    }
  }
}
</script>

<style>
.sportFootballMatchHeader{
  position:relative;
  display: block;
  height:70px;
  width:auto;
  background-color:white;
  transition-duration: 1s;
  transition-property: opacity;
  opacity: 0;
}
.sportFootballMatchHeader.loaded{
  opacity: 1;
}
.sportFootballMatchHeader span{
  position: absolute;
  display: block;
  width: auto;
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: bold;
}
.sportFootballMatchHeader .competition{
  color: var(--color-font-grey);
  left: 42px;
  top: 14px
}
.sportFootballMatchHeader .match{
  left: 42px;
  top: 38px
}
.sportFootballMatchHeader .user{
  top: 23px;
  right: 30%;
  font-size: 14px
}
.sportFootballMatchHeader .user{
  color:var(--color-error)
}
.sportFootballMatchHeader .user[data-connected="true"]{
  color:var(--color-error-warning)
}
.sportFootballMatchHeader .user[data-connected-match="true"]{
  color:var(--color-error-no)
}
.sportFootballMatchHeader .status{
  top: 23px;
  left: 30%;
  margin-left: 100px
}
.sportFootballMatchHeader .stopwatch{
  height: 40px;
  line-height: 40px;
  top: 15px;
  left: 30%;
  font-size: 28px
}
.sportFootballMatchHeader .live{
  top: 40px;
  left: 30%;
  margin-left: 100px
}
</style>
